import React, { Component } from 'react';
//import './Style.css';
import '../../custom.css'

export function Loading(props) {
    return (
        <div className="loading">
            <div class="spinner-grow" role="status">
                <span class="sr-only">Cargando...</span>
            </div>
            <div className="back"></div>
        </div>
    );
}
